import { Link, useSearchParams } from "react-router-dom";
import Card from "../layouts/Card";
import white from "/cywe-assets/card/white.png";
import Button from "../layouts/Button";
import shirtFront from "/shirts/front.webp";
import shirtFull from "/shirts/full.webp";
import shirtBack from "/shirts/back.webp";
import { useRef, useState } from "react";
import { EmailInput, TextInput } from "../layouts/Inputs";

export default function Shirt() {
	const [searchParams, _setSearchParams] = useSearchParams();

	const color = searchParams.get("color")!;

	const [sent, setSent] = useState(false);
	const [showPopup, setShowPopup] = useState(false);

	const nameRef = useRef<HTMLInputElement>(null);
	const emailRef = useRef<HTMLInputElement>(null);
	const commentRef = useRef<HTMLInputElement>(null);

	return (
		<>
			<div className={showPopup ? "brightness-25" : ""}>
				<Card bg={white}>
					<div className="min-h-screen flex flex-col items-center justify-center gap-4">
						<h1 className="text-4xl font-bold text-center">
							Would you like a shirt made with your color?
						</h1>
						<div className="flex flex-col items-center gap-4 lg:flex-row mb-4 ml-4 mr-4">
							<img src={shirtFront} className="w-64 h-full" />
							<img src={shirtFull} className="w-96 h-full" />
							<img src={shirtBack} className="w-64 h-full" />
						</div>
					</div>
					<div className="flex gap-4 absolute bottom-4 right-4">
						{sent ? (
							<Button>
								<span className="text-green-700">Request Sent!</span>
							</Button>
						) : (
							<Button
								onClick={() => {
									setShowPopup(true);
								}}
							>
								Send Request
							</Button>
						)}
						<Link to={`/donate?${searchParams.toString()}`}>
							<Button>Next</Button>
						</Link>
					</div>
				</Card>
			</div>
			{showPopup && (
				<div className="absolute top-4 left-[50%] translate-x-[-50%] max-w-100">
					<div className="flex flex-col bg-gray-50 p-4 rounded-md">
						<div className="flex gap-4 items-center self-center text-2xl font-bold">
							<div
								className="size-[0.75lh] rounded-full"
								style={{
									backgroundColor: color,
								}}
							></div>
							<h1>Request Shirt</h1>
							<div
								className="size-[0.75lh] rounded-full"
								style={{
									backgroundColor: color,
								}}
							></div>
						</div>

						<label className="pt-4">Your Name:</label>
						<TextInput ref={nameRef} />

						<label className="pt-4">Your Email:</label>
						<EmailInput ref={emailRef} />

						<label className="pt-4">Comment:</label>
						<TextInput ref={commentRef} />

						<div className="flex gap-4 pt-4">
							<Button onClick={() => setShowPopup(false)}>Cancel</Button>
							<Button
								onClick={async () => {
									if (!emailRef.current?.validity.valid) {
										alert("Invalid email");
										return;
									}

									if (!nameRef.current?.value) {
										alert("Missing name");
										return;
									}

									// Create form data object
									const data = new FormData();

									data.set("name", nameRef.current?.value);
									data.set("email", emailRef.current?.value);
									data.set("color", color);

									if (commentRef.current?.value)
										data.set("comment", commentRef.current?.value);

									// Send request
									await fetch("/api/request-shirt", {
										method: "post",
										body: data,
									});

									// Finish popup prompt
									setShowPopup(false);
									setSent(true);
								}}
							>
								Send
							</Button>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
